<div class="address-container">
    @if (isLoading) {
    <mat-spinner [diameter]="50" strokeWidth="2" class="loading-spinner"></mat-spinner>
    }
    <div class="top-section">
        <div class="back-title-container">
            <div class="back-icon-container" (click)="goBack()">
                <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
            </div>
            <div>
                <div class="title-container">
                    <div class="icon-container">
                        <mat-icon svgIcon="location" class="location-icon"></mat-icon>
                    </div>
                    <p class="title font-poppins">Address</p>
                </div>
    
                <p class="subtitle">Add, edit, or remove your shipping addresses</p>
            </div>
        </div>

        <button mat-flat-button class="btn-primary-gradient add-address-button" (click)="addOrEditAddress()">
            <span class="plus-icon">+</span>
            <span>Add New Address</span>
        </button>
    </div>

    <div class="address-list-container">
        @for (address of currentUserAddresses; track address.id) {
        <div class="address" [ngClass]="{ 'active-address': address.isDefault }">
            <p class="name font-poppins">{{ address.name }}</p>
            <p class="address-type">{{ address.addressType }}</p>
            <p class="icon-label">
                <span class="icon-container">
                    <mat-icon svgIcon="location" class="location-icon"></mat-icon>
                </span>
                <span class="address-details"
                    >{{ address.address }}, {{ address.city }}, {{ address.state }}, {{ address.pincode }}</span
                >
            </p>
            <p class="icon-label">
                <span class="icon-container">
                    <mat-icon svgIcon="phone" class="phone-icon"></mat-icon>
                </span>
                <span>+91 {{ address.mobileNumber }}</span>
            </p>
            <div class="separator"></div>
            <div class="action-container">
                <div class="left-section">
                    <button
                        mat-icon-button
                        class="edit-button icon-button-overlay-remove"
                        (click)="addOrEditAddress(address)"
                    >
                        <mat-icon class="edit-icon">edit</mat-icon>
                    </button>

                    <button
                        mat-icon-button
                        class="remove-button icon-button-overlay-remove"
                        [disabled]="address.isDefault"
                        (click)="deleteAddress(address)"
                    >
                        <mat-icon class="close-icon">delete</mat-icon>
                    </button>
                </div>

                <div class="right-section">
                    <span class="toggle-label">Set Default</span>
                    <mat-slide-toggle
                        class="default-toggle"
                        [checked]="address.isDefault"
                        [disabled]="address.isDefault"
                        (change)="setAsDefault(address.id)"
                    ></mat-slide-toggle>
                </div>
            </div>
        </div>
        }
    </div>

    <button mat-flat-button class="btn-primary-gradient bottom-btn" (click)="addOrEditAddress()">
        <span class="plus-icon">+</span>
        <span>Add New Address</span>
    </button>
</div>
